import { useLazyQuery } from '@apollo/client/react';
import { useEffect } from 'react';

import {
  GetLineVisitDetailDocument,
  LineVisitorAppointmentDetailFragment,
} from '~/graphql/generated/graphql';
import { getNode } from '~/graphql/utility';
import { useSubscriptions } from '~/hooks/use-subscriptions';

export const useFetchAppointment = (
  isOpen: boolean,
  appointmentId: string | null,
): {
  loading: boolean;
  appointment?: LineVisitorAppointmentDetailFragment;
} => {
  const [event, clear] = useSubscriptions('Appointment', ['updated']);

  const [getLineVisit, { loading, data }] = useLazyQuery(GetLineVisitDetailDocument, {
    fetchPolicy: 'network-only',
  });
  const appointment = getNode(data, 'Appointment');

  useEffect(() => {
    if (event) {
      clear();
    }
  }, [event, clear]);

  useEffect(() => {
    (async () => {
      if (isOpen && appointmentId) {
        await getLineVisit({
          variables: {
            id: appointmentId,
          },
        });
      }
    })();
  }, [getLineVisit, isOpen, appointmentId]);

  useEffect(() => {
    if (event?.actionName === 'updated' && event.typeId === appointmentId) {
      (async () => {
        await getLineVisit({ variables: { id: appointmentId } });
      })();
    }
  }, [appointmentId, event?.actionName, event?.typeId, getLineVisit]);

  return { loading, appointment };
};
